import React from 'react';
import { DashboardChartBox, HeaderTitle } from '../styles';

interface SurveyCompletionAnalysisTableProps {
  totalPeopleFinishedSurveyByLastPageNumber: Record<string, number>;
}

const SurveyCompletionAnalysisTable: React.FC<
  SurveyCompletionAnalysisTableProps
> = ({ totalPeopleFinishedSurveyByLastPageNumber }) => (
  <DashboardChartBox>
    <div
      style={{
        flex: 1,
        flexDirection: 'column',
        display: 'flex',
      }}
    >
      <HeaderTitle>
        <p>Survey Completion Analysis</p>
      </HeaderTitle>
      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
        <table className="styled-table">
          <thead>
            <tr>
              <th>
                {`Last Completed Page Number`}
                <br />{' '}
                <span
                  style={{ fontSize: 12, fontStyle: 'italic' }}
                >{`Pages where "Finish" button was clicked`}</span>
              </th>
              <th>Count</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(totalPeopleFinishedSurveyByLastPageNumber).map(
              ([pageLabel, count]) => (
                <tr key={pageLabel}>
                  <td>{pageLabel}</td>
                  <td>{count}</td>
                </tr>
              ),
            )}
          </tbody>
        </table>
      </div>
    </div>
  </DashboardChartBox>
);

export default SurveyCompletionAnalysisTable;
